export const ANIMATION_WAIT = 500;

export const SM_TABS_OFFSET = 425;
export const MD_TABS_OFFSET = 355;
export const LG_TABS_OFFSET = 520;

export const SCROLL_TRACK_TOP_OFFSET = 200;

export const TAG_NAME_TRACK_MAPPING = {
    gender_132: 'women',
    gender_134: 'men',
    gender_136: 'kids',
    58: 'home',
};

export enum TabIds {
    ALL = '1',
    MEN = '3',
    WOMEN = '2',
    KIDS = '4',
}

export const TAB_SWIPE_TRACK_EVENT_NAME = 'campaignOverview_categoryTab_swipe';
export const TAB_CLICK_TRACK_EVENT_NAME = 'campaignOverview_categoryTab_click';
export const SCROLL_TRACK_EVENT_NAME = 'campaignOverview_scroll';
